import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { React, Suspense } from 'react';
import { createMemoryHistory } from 'history';
import { HelmetProvider } from 'react-helmet-async';
import smoothscroll from 'smoothscroll-polyfill';
import './i18n';

import { PATH } from './constants';

import ErrorBoundary from './components/ErrorHandling/ErrorBoundary/ErrorBoundary';
import HelpAndSupport from './components/Layout/HelpAndSupport/HelpAndSupport';
import Category from './components/Layout/Category/Category';
import Entry from './components/Layout/Entry/Entry';
import SearchResult from './components/Layout/SearchResult/SearchResult';
import PageNotFound from './components/Layout/Error/PageNotFound/PageNotFound';
import ScrollToTop from './components/UI/ScrollToTop/ScrollToTop';

const App = () => {
    const history = createMemoryHistory();
    const bodyElement = document.getElementsByTagName('body')[0];
    bodyElement.className = 'hs-body';
    smoothscroll.polyfill();

    return (
        <Suspense fallback={<></>}>
            <ErrorBoundary>
                <HelmetProvider>
                    <Router location={history.location} navigator={history}>
                        <div style={{ 'background': 'white' }}>
                            <main>
                                <ScrollToTop>
                                    <Routes>
                                        <Route
                                            exact
                                            path={`${PATH.helpAndSupport}/search`}
                                            element={<SearchResult />}
                                        />
                                        <Route
                                            path={`${PATH.helpAndSupport}/`}
                                            element={<HelpAndSupport />}
                                        />
                                        <Route
                                            path={`${PATH.helpAndSupport}/:category/:entry`}
                                            element={<Entry />}
                                        />
                                        <Route
                                            path={`${PATH.helpAndSupport}/:category`}
                                            element={<Category />}
                                        />
                                        <Route path="*" element={<PageNotFound />} />
                                    </Routes>
                                </ScrollToTop>
                            </main>
                        </div>
                    </Router>
                </HelmetProvider>
            </ErrorBoundary>
        </Suspense>
    );
};

export default App;
